// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const GeneralCsvSeparator = t.struct({
    allowedCsvSeparators: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'GeneralCsvSeparator',
    strict: true
});

export const getDefaultState = () => new GeneralCsvSeparator({
    allowedCsvSeparators: [],
    key: '',
    value: ''
});

export default GeneralCsvSeparator;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/general-csv-separator.js